exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contentNotif {\n  line-height: 1.2 !important;\n}\n.listeNotifications {\n  overflow:   auto;\n  min-height:   85px;\n  max-height:   255px;\n}\n.positionCentralNotif {\n      position: fixed;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/watcheezy/WzNotifications.vue
// module id = pRGD
// module chunks = 1